import { z } from 'zod'

import { FilterOperator } from 'common/filter/filterConstants'

import { FilterGroupSchema } from '../filters'

export const SmartSegmentFilterSchema = z.object({
  operator: z.enum(FilterOperator),
  groups: z.array(FilterGroupSchema),
})

export const SmartSegmentSchema = z.object({
  segment_id: z.number(),
  id: z.string().optional(),
  title: z.string(),
  filter: SmartSegmentFilterSchema,
  description: z.string().nullish(),
})

export type SmartSegment = z.infer<typeof SmartSegmentSchema>

export type SmartSegmentFilter = z.infer<typeof SmartSegmentFilterSchema>
